import { Directive, ElementRef, HostBinding, Input } from '@angular/core';

import { HybridCommunicationService } from './infrastructure';

@Directive({
    selector: '[pHybrid]'
})
export class HybridDirective {
    @HostBinding('class.legacy-app')
    get legacyApp(): boolean {
        return true;
    }

    @Input()
    set isIframeCollapsed(value: boolean) {
        this.communication.isIframeCollapsed = value;
    }

    @Input()
    set isFloatingIframe(value: boolean) {
        this.communication.isFloatingIframe = value;
    }

    @Input()
    set iframe(value: HTMLIFrameElement) {
        this.communication.iframe = value;
    }

    constructor(el: ElementRef, private readonly communication: HybridCommunicationService) {
        communication.iframe = el.nativeElement as HTMLIFrameElement;
    }
}
